export default __webpack_public_path__ + "static/media/AddONGimg1.92b172fe.png";